
import { useEffect, useState } from "react";
import styles from "./page.module.scss";
 import { Box, Card } from "@chakra-ui/react";
import { useRef } from "react";
import { Button } from "@chakra-ui/react";
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
  } from '@chakra-ui/react'
const Dashbord = () => {


const [flag,setFlag] = useState(false)
  const bussinuss_Name = useRef("");
  const Account_No = useRef("");
  console.log(bussinuss_Name);
  console.log(Account_No);

  const [apiKey, setApiKey] = useState("hazrar@gamil.com");
  const [compName , setCompName] = useState("bharat bajwa");
    return (
        <>

         <Box  background ="linear-gradient(45deg, #F27121, #E94057, #8A2387)"
      
        
        //  circle at 24.1% 68.8%, rgb(50, 50, 50) 0%, rgb(0, 0, 0) 99.4%
         height="50vh">

        
            <div className={styles.main}>
          

                <div className={styles.compName}>
                    <div className={styles.a}>


                        <div className={styles.companeyName}>
                         Name - {compName}
                        </div>
                        <div 
                          onClick={()=>{
                             
                              setFlag(true)
                              
                            }}
                        className={styles.join}>
                            add account

                        </div>
                    </div>
                    <div className={styles.data}>
                        <div className ={styles.tex}>
                        your gmail :  {apiKey}
                        </div>
                      
                    </div>
                    



                </div>
      {
        flag?
     
         ( <div  className={styles.modalContainer}>
            
           <div  className={styles.model}>
               
{/*           
               <div style={{marginTop:"5px"}}>
           
           
                  <h3>bussinuss Name</h3>
                <input className={styles.input} ref={bussinuss_Name}/>
                </div> */}
                <div style={{marginTop:"5px"}}>
                <h3>Accounnt Address</h3>
                <input className={styles.input} ref={Account_No}/>
                </div>
               

               <button onClick={()=>{
                setFlag(false)
               }}
               className={styles.button}>
               Submit
           </button>
           </div>
          
          </div>
      ): <></>}

 


            </div>
            </Box>
         
            <div className={styles.aligncard}>
     

                <Card mt="10vh"
                border={5}

                mb={5}
                borderColor="balck"
                height="50vh"

                // background =" radial-gradient(circle at 18.7% 37.8%, rgb(250, 250, 250) 0%, rgb(225, 234, 238) 90%)"
                border-borderRadius= {8}
                sx={{
                    background:
                      'linear-gradient( #fff 0 0) padding-box, linear-gradient(to right top, #555555, #404040, #2c2c2c, #1a1a1a, #000000) border-box',
                    border: '3px solid transparent',
            
                  }}
                //   background-image: linear-gradient(to right top, #555555, #404040, #2c2c2c, #1a1a1a, #000000);

                  boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      borderRadius="26px"
                
                >
{/* 
               
                <div className={styles.card}>
                    <div className={styles.body}>
                        <div className={styles.bodytext}>
                         Accounts
                        </div>
                        <div className={styles.bodytext}>
                            flow-rate
                        </div>
                        <div className={styles.bodytext}>
                            Active/Deactive
                        </div>
                    </div>

                </div> */}
                <TableContainer paddingTop={5}>
                  {/*colorScheme=" teal" */}
  <Table variant='striped'  bgGradient='linear-gradient(45deg, #F27121, #E94057, #8A2387)'  width="100vh"  border={5 } paddingTop={5}>
    {/* <TableCaption>Imperial to metric conversion factors</TableCaption> */}
    <Thead>
      <Tr >
        <Th color="white">Accounts</Th>
  
        <Th  color="white">current value</Th>
        <Th  color="white">Thresold  value</Th>
        <Th  color="white" isNumeric>Delete</Th>
      </Tr>
    </Thead>
    <Tbody>
      <Tr>
        <Td>inches</Td>
        <Td>millimetres (mm)</Td>
        <Td>millimetres (mm)</Td>
        <Td isNumeric>
          
          <Button background="transparent">
            chick here</Button></Td>
      </Tr>
      <Tr>
        <Td>feet</Td>
        <Td>centimetres (cm)</Td>
     
        <Td >30.48</Td>
        <Td isNumeric>
          
          <Button background="transparent">
            chick here</Button></Td>
      </Tr>
      <Tr>
        <Td>yards</Td>
        <Td>metres (m)</Td>
        <Td >0.91444</Td>
  
        <Td isNumeric>
          
          <Button background="transparent">
            chick here</Button></Td>
      </Tr>
    </Tbody>
    {/* <Tfoot>
      <Tr>
        <Th>To convert</Th>
        <Th>into</Th>
        <Th isNumeric>multiply by</Th>
      </Tr>
    </Tfoot> */}
  </Table>
</TableContainer>

            
                </Card>
            </div>
            


        </>
    )
}

export default Dashbord;
